import { iif, throwError, timer } from 'rxjs';
import { concatMap, retryWhen } from 'rxjs/operators';
function getDelay(backoffDelay, maxInterval) {
    return Math.min(backoffDelay, maxInterval);
}
function exponentialBackoffDelay(iteration, initialInterval) {
    return Math.pow(2, iteration) * initialInterval;
}
export function retryBackoff(config) {
    const { initialInterval, maxRetries = Infinity, maxInterval = Infinity, shouldRetry = () => true, backoffDelay = exponentialBackoffDelay, onError = () => {
    }, } = typeof config === 'number' ? { initialInterval: config } : config;
    return (source) => source.pipe(retryWhen((errors) => errors.pipe(concatMap((error, i) => {
        onError(error);
        return iif(() => i < maxRetries && shouldRetry(error), timer(getDelay(backoffDelay(i, initialInterval), maxInterval)), throwError(error));
    }))));
}

//# sourceMappingURL=retryBackoff.js.map
